import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import SvgLoader from '@/utils/SvgLoader.vue';
import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextIconButton',
  props: {
    text: {},
    icon: {},
    propDisabled: { type: Boolean },
    colorStyle: { default: 'default' },
    isIconLeftSide: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const disabled = ref<boolean>(props.propDisabled ?? false);

watch(
  () => props.propDisabled,
  (newVal) => (disabled.value = newVal ?? false)
);

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["text-icon-button", `text-icon-button--${_ctx.colorStyle}`]),
    disabled: disabled.value,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    (_ctx.isIconLeftSide)
      ? (_openBlock(), _createBlock(SvgLoader, {
          key: 0,
          name: props.icon
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.text) + " ", 1),
    (!_ctx.isIconLeftSide)
      ? (_openBlock(), _createBlock(SvgLoader, {
          key: 1,
          name: props.icon
        }, null, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})